var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import firebase from 'firebase/app';
import { injectable } from 'tsyringe';
let CloudStorageDataSource = class CloudStorageDataSource {
    async upload(file, filename, path, metadata) {
        const storageRef = firebase.storage().ref();
        const ref = storageRef.child(`${path}/${filename}`);
        const result = await ref.put(file, { customMetadata: metadata !== undefined ? metadata : null });
        const url = await ref.getDownloadURL();
        console.log(result);
        return {
            path: result.ref.fullPath,
            url: url,
            metadata: result.metadata,
        };
    }
    async loadDownloadUrl(filename, path) {
        const storageRef = firebase.storage().ref();
        const ref = storageRef.child(`${path}/${filename}`);
        const result = await ref.getDownloadURL();
        return result;
    }
    async remove(filename, path) {
        const storageRef = firebase.storage().ref();
        const ref = storageRef.child(`${path}/${filename}`);
        const result = await ref.delete();
        console.log(result);
        return result;
    }
};
CloudStorageDataSource = __decorate([
    injectable()
], CloudStorageDataSource);
export { CloudStorageDataSource };
